import { ComponentsContext, IComponentsContext } from "@/contexts";
import { useContext } from "react";

export function useComponents(): IComponentsContext {
  const context = useContext(ComponentsContext);

  if (!context) {
    throw new Error("useComponents must be used within a ComponentProvider");
  }

  return context;
}
